import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import { DotWithLabel } from "../../outbound/freightDetails/LaneDetails/TonnageSummary";
import { InboundAppointmentSummary } from "../../../hooks/react-query/useInboundAppointmentSumary";

export type ProgressBarTypes = {
  current: number;

  total: number;

  isSelected?: boolean;

  hasFinalDestinations?: boolean;
  summary: InboundAppointmentSummary;
};

const ShipmentsPlannedProgressBarWithLabel = ({
  current,
  total,
  isSelected = false,
  hasFinalDestinations = false,
  summary,
}: ProgressBarTypes) => {
  const theme = useTheme();
  const plannedRatio = total > 0 ? current / total : 0;
  const unplannedRatio = 1 - plannedRatio;
  const {
    filteredPlannedShipments,
    totalPalletsPlanned,
    totalPiecesPlanned,
    totalWeightPlanned,
    filteredUnplannedShipments,
    totalPalletsUnplanned,
    totalPiecesUnplanned,
    totalWeightUnplanned,
  } = summary;

  return (
    <Box>
      <Box display="flex" aria-label="Bills planned">
        <Tooltip
          title={
            <Box>
              <Typography fontSize={15}>Planned</Typography>
              <Typography>{`${filteredPlannedShipments.length} Bills`}</Typography>
              <Typography>{`${totalPalletsPlanned} Plts`}</Typography>
              <Typography>{`${totalPiecesPlanned} Pcs`}</Typography>
              <Typography>{`${totalWeightPlanned.toLocaleString()} lbs`}</Typography>
            </Box>
          }
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: theme.palette.primary.dark,
                "& .MuiTooltip-arrow": {
                  color: theme.palette.primary.dark,
                },
              },
            },
          }}
        >
          <Box
            sx={{
              minWidth: "0px",
              flex: `${plannedRatio * 100}%`,
              backgroundColor: theme.palette.success.main,
              cursor: "pointer",
              height: "10px",
              marginTop: isSelected ? "-1px" : 0,
              opacity: hasFinalDestinations && !isSelected ? 0.2 : 1,
              borderRadius: "4px 0 0 4px",
              border: isSelected
                ? `2px solid ${theme.palette.common.white}`
                : "none",
              boxShadow: isSelected
                ? "0px 0px 4px 2px rgba(0, 0, 0, 0.3)"
                : "none",
              "&:hover": {
                boxShadow: "0px 0px 4px 2px rgba(0, 0, 0, 0.3)",
                border: `2px solid ${theme.palette.common.white}`,
                marginTop: "-1px",
              },
            }}
          />
        </Tooltip>

        <Tooltip
          title={
            <Box>
              <Typography fontSize={15}>Not Planned</Typography>
              <Typography>{`${filteredUnplannedShipments.length} bills`}</Typography>
              <Typography>{`${totalPalletsUnplanned} Plts`}</Typography>
              <Typography>{`${totalPiecesUnplanned} Pcs`}</Typography>
              <Typography>{`${totalWeightUnplanned.toLocaleString()} lbs`}</Typography>
            </Box>
          }
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: theme.palette.primary.dark,
                "& .MuiTooltip-arrow": {
                  color: theme.palette.primary.dark,
                },
              },
            },
          }}
        >
          <Box
            sx={{
              minWidth: "0px",
              flex: `${unplannedRatio * 100}%`,
              backgroundColor: theme.palette.grey[300],
              cursor: "pointer",
              height: "10px",
              marginTop: isSelected ? "-1px" : 0,
              opacity: hasFinalDestinations && !isSelected ? 0.2 : 1,
              borderRadius: "0 4px 4px 0",
              border: isSelected
                ? `2px solid ${theme.palette.common.white}`
                : "none",
              boxShadow: isSelected
                ? "0px 0px 4px 2px rgba(0, 0, 0, 0.3)"
                : "none",
              "&:hover": {
                boxShadow: "0px 0px 4px 2px rgba(0, 0, 0, 0.3)",
                border: `2px solid ${theme.palette.common.white}`,
                marginTop: "-1px",
              },
            }}
          />
        </Tooltip>
      </Box>

      <Box display="flex" alignItems="center" mt={1}>
        {total > 0 && (
          <DotWithLabel color={theme.palette.success.main} label="Planned " />
        )}
        <DotWithLabel label="Unplanned" color={theme.palette.grey[100]} />
      </Box>
    </Box>
  );
};
export default ShipmentsPlannedProgressBarWithLabel;
